var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_54_",
    style: {
      fill: "#29A4FC"
    },
    d: "M512,255.904c0,70.692-28.654,134.692-74.981,181.019S326.692,511.904,256,511.904 S121.308,483.25,74.981,436.924S0,326.597,0,255.904S28.654,121.212,74.981,74.885S185.308-0.096,256-0.096 s134.692,28.654,181.019,74.981S512,185.212,512,255.904z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2907_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2062_",
    style: {
      fill: "#1F3D5C"
    },
    d: "M510.71,281.714c-6.47,64.63-36.98,122.177-82.456,163.567 S322.335,511.904,256,511.904s-126.777-25.233-172.254-66.623S7.76,346.344,1.29,281.714H256H510.71z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2917_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2933_",
    style: {
      fill: "#C42437"
    },
    d: "M473.319,49.334v139.897v139.897c0,4.36-1.768,8.308-4.626,11.167 c-2.858,2.858-6.806,4.626-11.167,4.626h-203.86H49.807c-4.36,0-8.308-1.768-11.167-4.626s-4.626-6.806-4.626-11.167V189.231 V49.334c0-4.36,1.768-8.308,4.626-11.167s6.806-4.626,11.167-4.626h203.86h203.86c4.36,0,8.308,1.768,11.167,4.626 C471.551,41.026,473.319,44.974,473.319,49.334z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2932_",
    style: {
      fill: "#EB2433"
    },
    d: "M473.319,49.334v139.897v139.897c0,4.36-1.768,8.308-4.626,11.167 c-2.858,2.858-6.806,4.626-11.167,4.626H296.795H136.065c-4.36,0-8.308-1.768-11.167-4.626s-4.626-6.806-4.626-11.167V189.231 V49.334c0-4.36,1.768-8.308,4.626-11.167s6.806-4.626,11.167-4.626h160.731h160.731c4.36,0,8.308,1.768,11.167,4.626 C471.551,41.026,473.319,44.974,473.319,49.334z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2931_",
    style: {
      fill: "#A31E34"
    },
    d: "M442.7,75.615v113.709v113.709c0,4.36-1.768,8.308-4.626,11.167 c-2.858,2.858-6.806,4.626-11.167,4.626h-173.24H80.427c-4.36,0-8.308-1.768-11.167-4.626c-2.858-2.858-4.626-6.806-4.626-11.167 V189.324V75.615c0-4.366,1.768-8.314,4.626-11.171c2.858-2.857,6.806-4.622,11.167-4.622h173.24h173.24 c4.36,0,8.308,1.765,11.167,4.622C440.931,67.302,442.7,71.25,442.7,75.615z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2930_",
    style: {
      fill: "#BA2033"
    },
    d: "M442.7,75.615v113.709v113.709c0,4.36-1.79,8.308-4.682,11.167 c-2.893,2.858-6.889,4.626-11.301,4.626H279.542H132.367c-4.413,0-8.409-1.768-11.301-4.626 c-2.893-2.858-4.682-6.806-4.682-11.167V189.324V75.615c0-4.366,1.79-8.314,4.682-11.171c2.893-2.857,6.889-4.622,11.301-4.622 h147.174h147.174c4.413,0,8.409,1.765,11.301,4.622C440.91,67.302,442.7,71.25,442.7,75.615z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2923_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2927_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2929_",
    style: {
      fill: "#D4D2D2"
    },
    d: "M333.529,164.209c0,20.186-7.491,38.623-19.844,52.684 c-12.353,14.06-29.568,23.744-49.016,26.421c-1.797,0.253-3.614,0.442-5.449,0.568s-3.686,0.189-5.553,0.189 c-22.052,0-42.017-8.94-56.47-23.392c-14.453-14.453-23.392-34.418-23.392-56.47s8.94-42.017,23.392-56.47 c14.453-14.453,34.418-23.392,56.47-23.392c1.866,0,3.718,0.063,5.553,0.189c1.835,0.126,3.652,0.316,5.449,0.568 c19.448,2.677,36.663,12.36,49.016,26.421C326.038,125.586,333.529,144.023,333.529,164.209z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2928_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M333.529,164.209c0,20.186-7.491,38.623-19.844,52.684 c-12.353,14.06-29.568,23.744-49.016,26.421c-19.448-2.677-36.663-12.36-49.016-26.421 c-12.353-14.06-19.844-32.498-19.844-52.684s7.491-38.623,19.844-52.684s29.568-23.744,49.016-26.421 c19.448,2.677,36.663,12.36,49.016,26.421C326.038,125.586,333.529,144.023,333.529,164.209z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2924_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2926_",
    style: {
      fill: "#C23C4D"
    },
    d: "M309.31,150.534v13.675v13.675c0,2.603-1.056,4.961-2.763,6.668 c-1.707,1.707-4.065,2.763-6.668,2.763h-6.837h-6.837c-2.603,0-4.961,1.056-6.668,2.763c-1.707,1.707-2.763,4.065-2.763,6.668 v6.837v6.837c0,2.603-1.056,4.961-2.763,6.668c-1.707,1.707-4.065,2.763-6.668,2.763h-13.675h-13.675 c-2.603,0-4.961-1.056-6.668-2.763c-1.707-1.707-2.763-4.065-2.763-6.668v-6.837v-6.837c0-2.603-1.056-4.961-2.763-6.668 c-1.707-1.707-4.065-2.763-6.668-2.763h-6.837h-6.837c-2.603,0-4.961-1.056-6.668-2.763s-2.763-4.065-2.763-6.668v-13.675 v-13.675c0-2.603,1.056-4.961,2.763-6.668s4.065-2.763,6.668-2.763h6.837h6.837c2.603,0,4.961-1.056,6.668-2.763 c1.707-1.707,2.763-4.065,2.763-6.668v-6.838v-6.837c0-2.603,1.056-4.961,2.763-6.668c1.707-1.707,4.065-2.763,6.668-2.763 h13.675h13.675c2.603,0,4.961,1.056,6.668,2.763c1.707,1.707,2.763,4.065,2.763,6.668v6.837v6.838 c0,2.603,1.056,4.961,2.763,6.668c1.707,1.707,4.065,2.763,6.668,2.763h6.837h6.837c2.603,0,4.961,1.056,6.668,2.763 C308.253,145.573,309.31,147.931,309.31,150.534z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2925_",
    style: {
      fill: "#F94755"
    },
    d: "M309.31,150.534v13.675v13.675c0,2.603-1.056,4.961-2.763,6.668 c-1.707,1.707-4.065,2.763-6.668,2.763h-6.837h-6.837c-2.603,0-4.961,1.056-6.668,2.763c-1.707,1.707-2.763,4.065-2.763,6.668 v6.837v6.837c0,2.603-1.056,4.961-2.763,6.668c-1.707,1.707-4.065,2.763-6.668,2.763h-3.301h-3.301 c-2.603,0-4.961-1.056-6.668-2.763c-1.707-1.707-2.763-4.065-2.763-6.668v-6.837v-6.837c0-2.603-1.056-4.961-2.763-6.668 c-1.707-1.707-4.065-2.763-6.668-2.763h-6.837h-6.837c-2.603,0-4.961-1.056-6.668-2.763c-1.707-1.707-2.763-4.065-2.763-6.668 v-13.675v-13.675c0-2.603,1.056-4.961,2.763-6.668c1.707-1.707,4.065-2.763,6.668-2.763h6.837h6.837 c2.603,0,4.961-1.056,6.668-2.763c1.707-1.707,2.763-4.065,2.763-6.668v-6.838v-6.837c0-2.603,1.056-4.961,2.763-6.668 c1.707-1.707,4.065-2.763,6.668-2.763h3.301h3.301c2.603,0,4.961,1.056,6.668,2.763c1.707,1.707,2.763,4.065,2.763,6.668v6.837 v6.838c0,2.603,1.056,4.961,2.763,6.668c1.707,1.707,4.065,2.763,6.668,2.763h6.837h6.837c2.603,0,4.961,1.056,6.668,2.763 C308.253,145.573,309.31,147.931,309.31,150.534z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2922_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M335.113,295.125h-81.446H172.22c-4.349,0-8.287-1.763-11.137-4.613 s-4.613-6.788-4.613-11.137v-1.548v-1.548c0-4.349,1.763-8.287,4.613-11.137s6.788-4.613,11.137-4.613h81.446h81.446 c4.349,0,8.287,1.763,11.137,4.613s4.613,6.788,4.613,11.137v1.548v1.548c0,4.349-1.763,8.287-4.613,11.137 S339.462,295.125,335.113,295.125z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2921_",
    style: {
      fill: "#D4D2D2"
    },
    d: "M173.805,27.599V44.26v16.661c0,2.779-1.126,5.294-2.947,7.114 c-1.822,1.82-4.339,2.946-7.124,2.946h-9.698h-9.698c-2.784,0-5.302-1.126-7.124-2.946c-1.822-1.82-2.947-4.335-2.947-7.114 V44.26V27.599c0-2.779,1.126-5.294,2.947-7.114c1.822-1.82,4.34-2.946,7.124-2.946h9.698h9.698c2.784,0,5.302,1.126,7.124,2.946 C172.679,22.306,173.805,24.821,173.805,27.599z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2920_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M173.805,27.599V44.26v16.661c0,2.779-1.126,5.294-2.947,7.114 c-1.822,1.82-4.339,2.946-7.124,2.946h-2.378h-2.378c-2.779,0-5.294-1.126-7.114-2.946c-1.82-1.82-2.946-4.335-2.946-7.114V44.26 V27.599c0-2.779,1.126-5.294,2.946-7.114c1.82-1.82,4.335-2.946,7.114-2.946h2.378h2.378c2.784,0,5.302,1.126,7.124,2.946 C172.679,22.306,173.805,24.821,173.805,27.599z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2919_",
    style: {
      fill: "#D4D2D2"
    },
    d: "M373.066,27.599V44.26v16.661c0,2.779-1.126,5.294-2.947,7.114 c-1.822,1.82-4.34,2.946-7.124,2.946h-9.698H343.6c-2.784,0-5.302-1.126-7.124-2.946c-1.822-1.82-2.947-4.335-2.947-7.114V44.26 V27.599c0-2.779,1.126-5.294,2.947-7.114c1.822-1.82,4.339-2.946,7.124-2.946h9.698h9.698c2.784,0,5.302,1.126,7.124,2.946 S373.066,24.821,373.066,27.599z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2918_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M373.066,27.599V44.26v16.661c0,2.779-1.126,5.294-2.947,7.114 c-1.822,1.82-4.34,2.946-7.124,2.946h-2.378h-2.378c-2.779,0-5.294-1.126-7.114-2.946c-1.82-1.82-2.946-4.335-2.946-7.114V44.26 V27.599c0-2.779,1.126-5.294,2.946-7.114c1.82-1.82,4.335-2.946,7.114-2.946h2.378h2.378c2.784,0,5.302,1.126,7.124,2.946 S373.066,24.821,373.066,27.599z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2914_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2916_",
    style: {
      fill: "#F5D6BA"
    },
    d: "M442.722,270.873H413.31h-29.411c-2.993,0-5.7,1.214-7.659,3.175 c-1.959,1.962-3.17,4.672-3.17,7.665v33.146v33.146h-21.902h-21.902c-11.102,0-21.169,4.516-28.46,11.808 c-7.292,7.292-11.808,17.358-11.808,28.46c0,0.404-0.164,0.771-0.43,1.036c-0.265,0.265-0.632,0.43-1.036,0.43h-63.085h-63.085 c-5.611,0-10.69,2.274-14.367,5.951c-3.677,3.677-5.951,8.756-5.951,14.367s2.274,10.69,5.951,14.367 c3.677,3.677,8.756,5.951,14.367,5.951h63.085h63.085c11.546,0,22.021-4.672,29.635-12.225 c7.614-7.553,12.366-17.986,12.466-29.509h25.381h25.381c0.205,0,0.407-0.009,0.609-0.022s0.402-0.028,0.604-0.04 c0.37,0.08,0.746,0.142,1.128,0.184c0.382,0.042,0.77,0.064,1.164,0.064h29.411h29.411c2.987,0,5.694-1.214,7.655-3.175 c1.96-1.962,3.174-4.672,3.174-7.664V329.85v-48.137c0-2.993-1.214-5.703-3.174-7.665 C448.416,272.086,445.709,270.873,442.722,270.873z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2915_",
    style: {
      fill: "#FAEDDE"
    },
    d: "M453.551,281.713v48.137v48.137c0,2.993-1.214,5.703-3.174,7.664 c-1.96,1.962-4.668,3.175-7.655,3.175h-14.717h-14.717c-2.993,0-5.7-1.214-7.659-3.175s-3.17-4.672-3.17-7.664V329.85v-48.137 c0-2.993,1.211-5.703,3.17-7.665c1.959-1.962,4.666-3.175,7.659-3.175h14.717h14.717c2.987,0,5.694,1.214,7.655,3.175 C452.337,276.01,453.551,278.72,453.551,281.713z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2911_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2913_",
    style: {
      fill: "#FDB67A"
    },
    d: "M412.761,438.975h-32.949h-32.949c-3.682,0-7.015-1.492-9.428-3.905 c-2.413-2.413-3.905-5.746-3.905-9.428v-1.31v-1.31c0-3.682,1.492-7.015,3.905-9.428c2.413-2.413,5.746-3.905,9.428-3.905h32.949 h32.949c3.682,0,7.015,1.492,9.428,3.905c2.413,2.413,3.905,5.746,3.905,9.428v1.31v1.31c0,3.682-1.492,7.015-3.905,9.428 C419.776,437.482,416.443,438.975,412.761,438.975z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2912_",
    style: {
      fill: "#FDA15F"
    },
    points: "392.991,438.978 379.811,438.978 366.632,438.978 366.632,424.333  366.632,409.688 379.811,409.688 392.991,409.688 392.991,424.333  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2908_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2910_",
    style: {
      fill: "#FDB67A"
    },
    d: "M173.15,379.424l-31.34,10.173l-31.34,10.173 c-3.502,1.137-7.133,0.746-10.173-0.804c-3.04-1.55-5.489-4.26-6.625-7.762l-0.405-1.246l-0.405-1.246 c-1.137-3.502-0.746-7.133,0.804-10.173c1.55-3.04,4.26-5.489,7.762-6.625l31.34-10.173l31.34-10.173 c3.502-1.137,7.133-0.746,10.173,0.804c3.04,1.55,5.489,4.26,6.625,7.762l0.405,1.246l0.405,1.246 c1.137,3.502,0.746,7.133-0.804,10.173C179.362,375.839,176.652,378.287,173.15,379.424z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2909_",
    style: {
      fill: "#FDA15F"
    },
    points: "154.347,385.531 141.812,389.6 129.276,393.669 124.755,379.74  120.233,365.81 132.768,361.741 145.304,357.672 149.825,371.602  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2906_",
    style: {
      fill: "#29A4FC"
    },
    points: "92.208,217.496 134.267,217.496 176.326,217.496 176.326,175.437  176.326,133.379 134.267,133.379 92.208,133.379 92.208,175.437  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.9569eecde04ceb461442a8db8e99c11d.svg";
export { ForwardRef as ReactComponent };